/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import CardCheckbox from './components/CardCheckbox'
import CardFooter from './components/CardFooter'
import Styles from './styles.module.sass'
import { Flex } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import CardBody from './components/CardBody'
import CardContent from './components/CardContent'

const ItemHorizontalCard = ({
  as,
  children,
  className = '',
  hasShadow = true,
  isLink,
  onAction,
  url,
  ...props
}) => {
  const linkClass = isLink ? 'cursor-pointer' : ''
  const shadowStyles = hasShadow
    ? Styles.hasShadow
    : ''
  const currentClass = `
    ${Styles.card} ${shadowStyles} ${linkClass} p-5 ${className}
  `
  const linkProps = isLink && url
    ? { as: Link, to: url }
    : {}

  return (
    <Flex
      as={as}
      className={currentClass}
      flexDirection="column"
      justifyContent="space-between"
      maxW={{ md: '400px' }}
      width={{
        base: '100%'
      }}
      { ...props }
      { ...linkProps }
    >
      { children }
    </Flex>
  )
}
ItemHorizontalCard.Body = CardBody
ItemHorizontalCard.Checkbox = CardCheckbox
ItemHorizontalCard.Footer = CardFooter
ItemHorizontalCard.Content = CardContent

export default ItemHorizontalCard
